import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PsfPromoteOrShareDataQuery } from '../api.graphql';
import type { Viewer } from '../types';

export function normalizeJoinTheCommunityCustomConfig(
	{ i18n }: UtilityContext,
	{
		viewer,
		fcmValues,
	}: {
		viewer: Viewer;
		fcmValues: PsfPromoteOrShareDataQuery['featureConfigs'];
	},
) {
	if (!fcmValues.joinCommunityFooterConfig) return undefined;

	const viewerCurrency = viewer.country.currency || { code: 'USD', exchangeRate: 1 };

	const {
		custom_promoter_count: promoterCount,
		custom_contribution_amount: contributionAmount,
		custom_additional_signatures: additionalSignatures,
	} = fcmValues.joinCommunityFooterConfig;

	return {
		promoterCount,
		promoterCountLocalized: i18n.localizeNumber(promoterCount),
		contributionAmount,
		contributionAmountLocalized: i18n.localizeCurrency(contributionAmount, viewerCurrency.code),
		additionalSignatures,
		additionalSignaturesLocalized: i18n.localizeNumber(additionalSignatures),
	};
}
